
<template>
  <div class="wrapper">
    <div class="overview-widget" v-if="report_data">
      <div class="chart-widget">
        <div class="chart-header">
          <h2>Organization</h2>
          <div class="option">
            <select v-if="false" class="time-frame-input">
              <option value="">Time frame</option>
              <option value="">Last week</option>
              <option value="">This month</option>
              <option value="">Last 5 months</option>
              <option value="">This year</option>
            </select>
          </div>
        </div>

        <div class="task-chart-widget">
          <div class="chart-container" v-if="false">
            <div class="chart">
              <div class="chart-header">
                <h2>Organization</h2>
              </div>
              <apexchart
                width="100%"
                height="100%"
                type="area"
                ref="organization_chart"
                :options="OrganizationChartOptions"
                :series="OrganizationChartOptions.series"
              ></apexchart>
            </div>
            <div class="task-info"></div>
          </div>
        </div>
        <div class="card-row">
          <div class="card-widget">
            <h1>{{ report_data.projects }}</h1>
            <h3>Projects</h3>
          </div>
          <div class="card-widget">
            <h1>{{ report_data.skills }}</h1>
            <h3>Skills</h3>
          </div>
          <div class="card-widget">
            <h1>{{ report_data.departments }}</h1>
            <h3>Departments</h3>
          </div>
          <div class="card-widget">
            <h1>{{ report_data.teams }}</h1>
            <h3>Teams</h3>
          </div>
        </div>
      </div>
      <div class="other-overview"></div>
    </div>
  </div>
</template>

<script>
import Chart from "chart.js";
import RadialProgressBar from "vue-radial-progress";
export default {
  name: "Tasks",
  components: {
    RadialProgressBar,
  },
  data() {
    return {
      completedSteps: 100,
      totalSteps: 83,
      view_type: "",
      selected_skill_type: "tools",
      count_skills: 0,
      OrganizationChartOptions: {
        colors: ["#0884AF"],
        chart: {
          toolbar: {
            show: false,
            tools: {
              download: false,
              selection: false,
              zoom: false,
              zoomin: false,
              zoomout: false,
              pan: false,
            },
          },
        },
        dataLabels: {
          enabled: false,
        },
        yaxis: {
          tickAmount: 4,
          labels: {
            formatter: (value) => {
              return value;
            },
          },
        },
        xaxis: {
          categories: [],
          labels: {
            show: true,
            trim: true,
            style: {
              fontSize: "8px",
            },
          },
        },
        series: [
          {
            name: "Value",
            data: [],
          },
        ],
      },
      report_data: null,
      report_other_data: null,
    };
  },

  methods: {
    getColor(color, index) {
      return color;
    },
    getReportOtherData() {
      let vm = this;
      vm.$store.dispatch("LOADER_START");
      vm.$store
        .dispatch("REPORT_GET_SOCIAL_ORGANIZATION")
        .then((response) => {
          vm.$store.dispatch("LOADER_CLOSE");
          vm.report_data = response.data;
          setTimeout(() => {
            vm.loadAccount();
          }, 500);
        })
        .catch((error) => {
          vm.$store.dispatch("LOADER_CLOSE");
          console.error({ error });
        });
    },
    getReportData() {
      let vm = this;
      vm.$store.dispatch("LOADER_START");
      vm.$store
        .dispatch("REPORT_GET_CRM_ORGANIZATION")
        .then((response) => {
          vm.$store.dispatch("LOADER_CLOSE");
          vm.report_other_data = response.data;
        })
        .catch((error) => {
          vm.$store.dispatch("LOADER_CLOSE");
          console.error({ error });
        });
    },
    loadAccount() {
      let vm = this;
      let leads_data = vm.report_data.graph.consultants.map((item) => {
        return parseInt(item);
      });
      vm.$refs.organization_chart.updateSeries(
        [
          {
            data: leads_data,
          },
        ],
        false,
        true
      );
      vm.$refs.organization_chart.updateOptions({
        xaxis: {
          categories: vm.report_data.graph.labels,
        },
        yaxis: {
          min: leads_data.min(),
          max: leads_data.max() == 0 ? 5 : leads_data.max(),
          tickAmount: 4,
          labels: {
            formatter: (value) => {
              return parseInt(value);
            },
          },
        },
      });
    },
    onParcent(value) {
      if (value > 12) {
        return (100 * value) / 15;
      } else {
        return (100 * value) / 15 + 15;
      }
    },
  },
  computed: {},
  mounted() {
    let vm = this;
    vm.getReportData();
    vm.getReportOtherData();
  },
  created() {
    Array.prototype.max = function () {
      return Math.max.apply(null, this);
    };

    Array.prototype.min = function () {
      return Math.min.apply(null, this);
    };
  },
};
</script>
<style lang="scss" scoped>
.wrapper {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  background: #fff !important;
  padding: 10px;
  border-radius: 5px;
  .overview-widget {
    display: grid;
    grid-template-columns: 74% 25%;
    grid-column-gap: 10px;
    .chart-widget {
      .chart-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 15px 10px;
        h2 {
          font-size: 18px;
          font-weight: 800;
          margin: 0px;
        }
        .option {
          .time-frame-input {
            height: 40px;
            border: 1px solid #ddd;
            outline: none;
            padding: 0 10px;
          }
        }
      }
      .card-row {
        display: grid;
        grid-template-columns: 24% 24% 24% 24%;
        grid-column-gap: 10px;
        padding: 15px 10px;
        .card-widget {
          height: 150px;
          background: #eeeeee;
          border-radius: 5px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          h1 {
            font-size: 48px;
            color: #0884af;
            margin: 0px;
          }
          h3 {
            font-size: 20px;
            color: #0884af;
            margin: 0px;
          }
        }
      }
      .task-chart-widget {
        padding: 0px 10px;
        padding-top: 10px;
        .chart-container {
          background: #eeeeee;
          border-radius: 5px;
          display: flex;
          height: 400px;
          .chart {
            width: 75%;
            height: 340px;
          }
          .task-info {
            width: 30%;
            border-left: 1px solid #ddd;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .task-section {
              border-bottom: 1px solid #ddd;
              width: 100%;
              display: flex;
              align-items: center;
              justify-content: center;
              flex-direction: column;
              height: 20%;
              label {
                color: #707070;
              }
              h2 {
                font-size: 18px;
                font-weight: 800;
                margin: 0px;
                margin-top: 5px;
              }
              &.active {
                label {
                  color: #1ba5a4;
                }
                h2 {
                  color: #1ba5a4;
                }
              }
            }
          }
        }
        .other-chart {
          margin-top: 10px;
          background: #eeeeee;
          border-radius: 5px;
          display: flex;
          height: 400px;
          .chart {
            width: 100%;
          }
        }
      }
    }
    .other-overview {
      display: flex;
      flex-direction: column;
      padding-top: 15px;
      .manager-widget {
        margin-bottom: 20px;
        padding: 10px;
        width: 100%;
        background: #eeeeee;
        border-radius: 5px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .profile-name {
          height: 90px;
          width: 90px;
          border: 1px solid #ddd;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          .profile-text {
            height: 75px;
            width: 75px;
            border-radius: 50%;
            background: #76e0e0;
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 30px;
            font-weight: 800;
          }
        }
        img {
          margin-bottom: 10px;
        }
        h1 {
          margin: 0px;
          font-size: 24px;
          color: #000;
          margin-bottom: 10px;
        }
        h3 {
          color: #252733;
          font-size: 17px;
          margin: 0px;
        }
        p {
          text-align: center;
        }
        h4 {
          margin: 6px 0px;
          color: #252733;
          font-size: 15px;
        }
        h5 {
          margin: 6px 0px;
          color: #252733;
          font-size: 15px;
        }
      }
      .candidates-widget {
        margin-bottom: 20px;
        width: 100%;
        background: #eeeeee;
        border-radius: 5px;
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        .header {
          padding: 10px 10px;
          color: #333333;
        }
        .body {
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .footer {
          padding: 10px 10px;
          display: flex;
          justify-content: space-between;
          .label-widget {
            .box-widget {
              display: flex;
              align-items: center;
              .box {
                height: 26px;
                width: 40px;
                background: #cde8e8;
                border-radius: 10px;
                margin-right: 7px;
                &.active {
                  background: #1ba5a4;
                }
              }
              .number {
                font-size: 25px;
                position: relative;
                top: 3px;
              }
            }
            .label-info {
              margin-top: 8px;
              text-align: center;
            }
          }
        }
      }
      .leads-widget {
        margin-bottom: 20px;
        width: 100%;
        background: #eeeeee;
        border-radius: 5px;
        .header {
          padding: 10px 10px;
          color: #333333;
        }
        .body {
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .footer {
          padding: 10px 10px;
          display: flex;
          justify-content: space-between;
          .label-widget {
            .box-widget {
              display: flex;
              align-items: center;
              .box {
                height: 26px;
                width: 40px;
                background: #c9e2ea;
                border-radius: 10px;
                margin-right: 7px;
                &.active {
                  background: #0884af;
                }
              }
              .number {
                font-size: 25px;
                position: relative;
                top: 3px;
              }
            }
            .label-info {
              margin-top: 8px;
              text-align: center;
            }
          }
        }
      }
    }
  }
}
</style>
